var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC6737",
    d: "M12 0L1.605 6v12L12 24l10.395-6V6L12 0zm6.134 14.995L12 18.491l-6.134-3.496v-6.99L12 4.51l6.134 3.496v6.989z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagento);
export default __webpack_public_path__ + "static/media/magento.7979c1cbcb7d9c80c1c21c13b37d1409.svg";
export { ForwardRef as ReactComponent };